import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { financeApi } from '../../api/finance';
import { PageHeader } from '../../components/PageHeader';
import { DataTable } from '../../components/DataTable';

/** The real trial balance - the isBalanced flag comes straight from the backend's genuine computation, never assumed true. */
export function TrialBalancePage() {
  const [asOfDate, setAsOfDate] = useState(new Date().toISOString().slice(0, 10));
  const trialBalanceQuery = useQuery({ queryKey: ['finance-trial-balance', asOfDate], queryFn: () => financeApi.getTrialBalance(asOfDate) });
  const data = trialBalanceQuery.data?.data;

  return (
    <div className="page">
      <PageHeader title="Trial Balance" actions={<a href={financeApi.trialBalancePdfUrl(asOfDate)} target="_blank" rel="noreferrer">Download PDF</a>} />

      <section className="card">
        <label>As of Date<input type="date" value={asOfDate} onChange={(e) => setAsOfDate(e.target.value)} /></label>

        {data && (
          <>
            <DataTable
              rows={data.accounts}
              rowKey={(a) => a.accountId}
              emptyMessage="No posted transactions yet."
              columns={[
                { header: 'Code', render: (a) => a.accountCode },
                { header: 'Account', render: (a) => a.accountName },
                { header: 'Debit', render: (a) => a.debit > 0 ? a.debit.toLocaleString() : '-' },
                { header: 'Credit', render: (a) => a.credit > 0 ? a.credit.toLocaleString() : '-' },
              ]}
            />
            <p>
              <strong>Total: Debit {data.totalDebit.toLocaleString()} · Credit {data.totalCredit.toLocaleString()}</strong>
              {' '}
              {data.isBalanced ? <span style={{ color: 'var(--vri-green, green)' }}>✓ Balanced</span> : <span style={{ color: 'red' }}>⚠ Not Balanced</span>}
            </p>
          </>
        )}
      </section>
    </div>
  );
}
